let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5r6Jm")).then(() => parcelRequire('7JkhE'));